/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Settlement_Bank_HtxInputs */

const vi_order_settlement_bank_htx = /** @type {(inputs: Order_Settlement_Bank_HtxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TK HTX`)
};

/**

* @param {Order_Settlement_Bank_HtxInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_settlement_bank_htx = /** @type {((inputs?: Order_Settlement_Bank_HtxInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Settlement_Bank_HtxInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_settlement_bank_htx(inputs)
});